<template>
  <div id="selection-content" v-clickSelection>
    <div v-if="selected" class="timeline-selection" :style="timelineWidthStyle">
      <span class="effect-chooser">
        <el-tooltip effect="dark" content="点击可添加入场动画" placement="top" :open-delay="2000">
          <div
            class="enter-effect-icon"
            :style="enterIconStyle"
            @click.stop="showEffectPopup({type: 'enter'}, $event)"
            @mousedown.stop
            v-analysis="ANALYSIS.inSet"
          >
            <i :class="'icon-enter-effect anim-' + entranceAnim.type"></i>
          </div>
        </el-tooltip>
        <div class="enter-effect-section" :style="enterSectionStyle"></div>
      </span>
      <span class="effect-chooser">
        <el-tooltip effect="dark" content="点击可添加出场动画" placement="top" :open-delay="2000">
          <div
            class="exit-effect-icon"
            :style="exitIconStyle"
            @click.stop="showEffectPopup({type: 'exit'}, $event)"
            @mousedown.stop
            v-analysis="ANALYSIS.outSet"
          >
            <i :class="['anim-' + exitAnim.type, 'anim-out']"></i>
          </div>
        </el-tooltip>
        <div class="exit-effect-section" :style="exitSectionStyle"></div>
      </span>
      <div v-dragStay class="stay-section" :style="staySectionStyle">
        <el-tooltip content="点击此处可快切换元素特效" class="item" effect="dark" placement="top">
          <div v-if="showStay && !sprites[0].locked" @click.stop="settingStayAnim">
            <i class="icon-stay-setting"></i>
          </div>
        </el-tooltip>

        <div v-if="!hasPathAnim && !handAnim">{{sprites.length < 2 ? '': sprites.length}}</div>
        <div v-else-if="hasPathAnim" class="path-animation-section" :style="pathAnimStyle">
          <el-tooltip content="点击此处可快切换元素特效" class="item" effect="dark" placement="top">
            <span v-if="!sprites[0].locked" @click.stop="settingStayAnim"></span>
          </el-tooltip>

          <div v-dragPath class="path-animation-handle" :style="pathAnimHandleStyle">
            <div></div>
          </div>
          <el-tooltip effect="dark" content="已设置循环运动" placement="top" :open-delay="1000">
            <span v-show="pathAnim.loop" class="loop-icon"></span>
          </el-tooltip>
        </div>
        <div v-else-if="handAnim" class="hand-animation-section" :style="handAnimStyle">
          <div v-dragHand class="hand-animation-handle" :style="handAnimHandleStyle">
            <div></div>
          </div>
          <el-tooltip effect="dark" content="拖拽右侧时间刻度可调节手绘速度" placement="top" :open-delay="1000">
            <span class="handAnim-icon"></span>
          </el-tooltip>
        </div>
      </div>
      <el-tooltip effect="dark" content="拖动小黑线，可改变素材的入场时间" placement="top" :open-delay="2000">
        <div v-dragLeft class="timeline-drag-left" :style="dragLeftStyle">
          <div></div>
        </div>
      </el-tooltip>
      <el-tooltip effect="dark" content="拖动小黑线，可改变素材的出场时间" placement="top" :open-delay="2000">
        <div v-dragRight class="timeline-drag-right" :style="dragRightStyle">
          <div></div>
        </div>
      </el-tooltip>
    </div>
    <div v-else class="no-selection" :style="timelineWidthStyle"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters([
      "Tool_Size",
      "MaterialPane_Size",
      "TOOL",
      "SelectScenes_Msg",
      "SelectSprites_Msg",
      "UserMsg"
    ]),
    // 下面是一堆样式
    timelineWidthStyle() {
      const style = {};
      style.width = this.forStyle.timelineWidth + "px";
      return style;
    },
    enterIconStyle() {
      const style = {};
      if (this.forStyle.transformStart < 1) {
        style.left = 0;
        if (this.forStyle.transformEnd < 1) {
          style.display = "none";
        }
      }
      style.transform =
        "translate(" + this.forStyle.transformStart + "px, 0px)";
      return style;
    },
    enterSectionStyle() {
      const style = {};
      style.transform =
        "translate(" + this.forStyle.transformStart + "px, 0px)";
      style.borderLeftWidth = this.forStyle.enterWidth + "px";
      style.left = -this.forStyle.enterWidth + "px";
      return style;
    },
    exitIconStyle() {
      const style = {};
      if (this.forStyle.transformEnd > this.forStyle.timelineWidth - 1) {
        style.left = "-36px";
        if (this.forStyle.stayWidth < 1) {
          style.display = "none";
        }
      }
      style.transform = "translate(" + this.forStyle.transformEnd + "px, 0px)";
      return style;
    },
    exitSectionStyle() {
      const style = {};
      style.transform = "translate(" + this.forStyle.transformEnd + "px, 0px)";
      style.borderLeftWidth = this.forStyle.exitWidth + "px";
      return style;
    },
    staySectionStyle() {
      const style = {};
      style.transform =
        "translate(" +
        (this.forStyle.stayWidth < 10
          ? this.forStyle.transformStart - 5
          : this.forStyle.transformStart) +
        "px, 0px)";
      style.width =
        (this.forStyle.stayWidth < 10 ? 10 : this.forStyle.stayWidth) + "px";
      style.backgroundColor =
        this.showStay && this.stayAnim.type !== "None" ? "#2279cc" : "#b4b8d6";
      return style;
    },
    dragLeftStyle() {
      const style = {};
      let num = 0;
      if (
        Math.abs(this.forStyle.transformEnd - this.forStyle.transformStart) < 1
      ) {
        num = -5;
      }
      style.transform =
        "translate(" + (this.forStyle.transformStart + num) + "px, 0px)";
      return style;
    },
    dragRightStyle() {
      const style = {};
      let num = 0;
      if (
        Math.abs(this.forStyle.transformEnd - this.forStyle.transformStart) < 1
      ) {
        num = 5;
      }
      style.transform =
        "translate(" + (this.forStyle.transformEnd + num) + "px, 0px)";
      return style;
    },
    pathAnimStyle() {
      const style = {};
      style.width = this.forStyle.pathAnimWidth + "px";
      style.left = 0;
      return style;
    },
    pathAnimHandleStyle() {
      const style = {};
      style.transform = "translate(" + this.forStyle.pathAnimWidth + "px, 0px)";
      return style;
    },
    handAnimStyle() {
      const style = {};
      style.width = this.forStyle.handAnimWidth + "px";
      style.left = 0;
      return style;
    },
    handAnimHandleStyle() {
      const style = {};
      style.transform = "translate(" + this.forStyle.handAnimWidth + "px, 0px)";
      return style;
    }
  },
  props: ["totalTime", "nowTime"],
  data() {
    return {
      ANALYSIS: {
        inSet: {
          category: "editor_time_axis",
          action: "click_in_transition_setting",
          label: "编辑器_时间轴_入场动效设置"
        },
        outSet: {
          category: "editor_time_axis",
          action: "click_out_transition_setting",
          label: "编辑器_时间轴_出场动效设置"
        },
        sinDragEnter: {
          category: "axis_enter_animation_setting",
          action: "drag_enter_ani_degree_sin_ele",
          label: "拖拽_时间轴_入场刻度_单素材"
        },
        multiDragEnter: {
          category: "axis_enter_animation_setting",
          action: "drag_enter_ani_degree_muti_ele",
          label: "拖拽_时间轴_入场刻度_多素材"
        },
        sinDragOut: {
          category: "axis_enter_animation_setting",
          action: "drag_exit_ani_degree_sin_ele",
          label: "拖拽_时间轴_出场刻度_单素材"
        },
        multiDragOut: {
          category: "axis_enter_animation_setting",
          action: "drag_exit_ani_degree_muti_ele",
          label: "拖拽_时间轴_出场刻度_多素材"
        },
        sinDragHand: {
          category: "axis_enter_animation_setting",
          action: "drag_degree_sin_ele",
          label: "拖拽_时间轴_手绘时间刻度_单素材"
        },
        stayAnim: {
          category: "stay_animation_quick_panel",
          action: "click_star",
          label: "点击停留动画快捷入口"
        }
      },
      selected: true, // 是否有元素被选中（是否生成梯形图）
      sprites: [], // 选中的元素集合
      pathSprites: [], // 路径动画元素
      handSprites: [], // 手绘动画元素
      entranceAnim: {
        // 入场时间对象
        type: "",
        start: 3000,
        end: 3500
      },
      enterTimeDown: 0, // 为左侧拖动改变入场时间
      stayAnim: {
        // 停留时间对象
        type: "None",
        start: 3500,
        end: 5000
      },
      exitAnim: {
        // 出场时间对象
        type: "",
        start: 5000,
        end: 5500
      },
      exitTimeDown: 0, // 为右侧拖动改变出场时间
      pathAnim: {
        end: 0,
        target: {},
        loop: false
      },
      pathAnimDownNum: 0, // 为路径动画拖动改变时间
      hasPathAnim: false,
      forStyle: {
        // 样式的集合
        timelineWidth: 0,
        transformStart: 0,
        transformEnd: 0,
        stayWidth: 0,
        enterWidth: 0,
        exitWidth: 0,
        pathAnimWidth: 0,
        gridTransform: 0,
        handAnimWidth: 0
      },
      dragLeft: false, // 判断左侧拖动是否进行中
      dragStay: false, // 判断停留拖动是否进行中
      isClick: false, // 拖动停留部分的时候不触发点击事件
      showStay: false,
      handAnim: false, // svg手绘入场
      drawingDuration: 0,
      dragHandDownNum: 0,
      changeData: [], // 撤销数据
      reData: []
    };
  },
  mounted() {
    this.initData();
    this.getStaySectionCss();
    this.$bus.on("spritesFlagTime", data => {
      // flag 拖动后入场时间改变
      this.initData();
      this.getStaySectionCss();
    });
    this.$bus.on("updateEffect_vue", data => {
      if (!data.type) return;
      this.initData();
      this.getStaySectionCss();
    });
    this.$bus.on("changePath_pathSetting", data => {
      if (
        this.selected &&
        this.hasPathAnim &&
        data.name === "pathEffectSetting"
      ) {
        this.pathAnim.end = data.end;
        this.pathAnim.loop = data.loop;
        this.forStyle.pathAnimWidth =
          ((this.pathAnim.end - this.entranceAnim.end) /
            1000 /
            this.totalTime) *
          this.forStyle.timelineWidth;
      }
    });
    this.$bus.on("undoRedoHandle", data => {
      // 撤销和恢复的事件
      if (data.type === "timeline_drag" || data.type === "path_changeTime" || data.type === 'updateEffects') {
        this.initData();
        this.getStaySectionCss();
        this.$bus.emit("spritesFlagChange", { data: true });
      }
    });
  },
  watch: {
    "Tool_Size.width": function(val, oldval) {
      // 根据画布的尺寸改变时间轴尺寸
      this.getStaySectionCss();
    },
    SelectSprites_Msg(val, oldval) {
      // 改变场景元素，重新计算spitesContent
      this.initData();
      this.getStaySectionCss();
    },
    totalTime(val, oldval) {
      this.initData();
      this.getStaySectionCss();
    },
    entranceAnim: {
      // 入场时间改变后的操作
      deep: true,
      handler: function() {
        if (!this.dragLeft && !this.dragStay) return;
        if (this.entranceAnim.start < 0) {
          this.entranceAnim.start = 0;
        }
        if (this.exitAnim.end > this.totalTime * 1000) {
          this.exitAnim.end = this.exitAnim.start;
        }
        for (let i = 0, len = this.sprites.length; i < len; i++) {
          this.sprites[i].updateEffect({
            exitAnim: {
              end: this.exitAnim.end,
              start: this.exitAnim.start
            },
            entranceAnim: {
              end: this.entranceAnim.end,
              start: this.entranceAnim.start
            }
          });
        }
        if (this.hasPathAnim) this.changePathTime();
        this.changeHandTime();
        this.$bus.emit("spritesFlagChange", { data: true });
      }
    }
  },
  methods: {
    initData() {
      // 初始化入场，停留，出场对象
      if (this.SelectSprites_Msg.length) {
        this.selected = true;
        this.sprites = [].concat(this.SelectSprites_Msg);
        let length = this.SelectSprites_Msg.length,
          firstEffect = this.sprites[0].effect,
          enterEnd = 20000,
          exitStart = 0,
          pathAnimEnd = 0;
        this.pathSprites = [];
        this.handSprites = [];
        this.entranceAnim.type = firstEffect.code;
        this.exitAnim.type = firstEffect.exitAnim.type;
        this.stayAnim.type = firstEffect.stayAnim.type;
        if (length === 1) {
          if (this.isSpecialEffect(firstEffect.code)) {
            this.showStay = false;
          } else {
            this.showStay = true;
          }
          if (firstEffect.code === "Hand") {
            this.handAnim = true;
            this.drawingDuration = firstEffect.drawingDuration;
          } else {
            this.handAnim = false;
          }
          if (firstEffect.pathAnim.end) {
            this.pathSprites.push(this.sprites[0]);
            this.hasPathAnim = true;
            this.pathAnim.target = Object.assign(
              {},
              firstEffect.pathAnim.target
            );
            this.pathAnim.loop = firstEffect.pathAnim.loop;
            pathAnimEnd = firstEffect.pathAnim.end;
            this.showStay = false;
          } else {
            this.pathSprites = [];
            this.hasPathAnim = false;
            this.pathAnimEnd = 0;
            this.pathAnim.target = {};
          }
        } else {
          this.hasPathAnim = false;
          this.showStay = false;
          this.handAnim = false;
        }
        for (let i = 0; i < length; i++) {
          if (this.sprites[i].effect.entranceAnim.end < enterEnd) {
            enterEnd = this.sprites[i].effect.entranceAnim.end;
          }
          if (this.sprites[i].effect.exitAnim.start > exitStart) {
            exitStart = this.sprites[i].effect.exitAnim.start;
          }

          if (i > 0) {
            if (
              this.sprites[i - 1].effect.code !== this.sprites[i].effect.code
            ) {
              this.entranceAnim.type = "Entrance";
            }
            if (
              this.sprites[i - 1].effect.exitAnim.type !==
              this.sprites[i].effect.exitAnim.type
            ) {
              this.exitAnim.type = "Exit";
            }
          }

          if (this.sprites[i].effect.code === "Hand") {
            this.handSprites.push(this.sprites[i]);
          }
        }
        if (exitStart > this.totalTime * 1000) {
          console.error("数据错误，元素时间超出总时间");
          exitStart = this.totalTime * 1000;
        }

        this.entranceAnim.end = enterEnd;
        this.stayAnim.start = enterEnd;
        this.stayAnim.end = exitStart;
        this.exitAnim.start = exitStart;
        this.pathAnim.end = pathAnimEnd;

        if (this.entranceAnim.type === "None") {
          this.entranceAnim.start = this.entranceAnim.end;
        } else {
          this.entranceAnim.start = this.entranceAnim.end - 500;
        }
        if (this.exitAnim.type === "None") {
          this.exitAnim.end = this.exitAnim.start;
        } else {
          this.exitAnim.end = this.exitAnim.start + 500;
        }
      } else {
        this.selected = false;
        this.sprites = [];
      }
    },
    getStaySectionCss() {
      // 获取样式的计算数据
      if (!this.Tool_Size) return;
      this.forStyle.timelineWidth = this.Tool_Size.width - 84;
      this.forStyle.stayWidth =
        ((this.exitAnim.start - this.entranceAnim.end) /
          1000 /
          this.totalTime) *
        this.forStyle.timelineWidth;
      this.forStyle.transformStart =
        (this.entranceAnim.end / 1000 / this.totalTime) *
        this.forStyle.timelineWidth;
      this.forStyle.transformEnd =
        this.forStyle.stayWidth + this.forStyle.transformStart;
      this.forStyle.enterWidth =
        ((this.entranceAnim.end - this.entranceAnim.start) /
          1000 /
          this.totalTime) *
        this.forStyle.timelineWidth;
      this.forStyle.exitWidth =
        ((this.exitAnim.end - this.exitAnim.start) / 1000 / this.totalTime) *
        this.forStyle.timelineWidth;
      if (this.hasPathAnim)
        this.forStyle.pathAnimWidth =
          ((this.pathAnim.end - this.entranceAnim.end) /
            1000 /
            this.totalTime) *
          this.forStyle.timelineWidth;
      if (this.handAnim)
        this.forStyle.handAnimWidth =
          (this.drawingDuration / 1000 / this.totalTime) *
          this.forStyle.timelineWidth;
      if (this.forStyle.pathAnimWidth > this.forStyle.stayWidth)
        this.forStyle.pathAnimWidth = this.forStyle.stayWidth;
      if (this.entranceAnim.start < 0) this.forStyle.enterWidth = 0;
      if (this.exitAnim.end > this.totalTime * 1000)
        this.forStyle.exitWidth = 0;
      this.forStyle.gridTransform =
        this.forStyle.timelineWidth / this.totalTime / 2;
    },
    toNowTime(e) {
      let nowTime =
        ((e.clientX - this.MaterialPane_Size.width - 30) /
          (this.Tool_Size.width - 84)) *
        this.totalTime;
      nowTime = Math.round(nowTime * 2) / 2;
      if (
        nowTime * 1000 < this.entranceAnim.end ||
        nowTime * 1000 > this.exitAnim.start
      ) {
        this.TOOL.selectSprite(null);
      }
      this.$emit("update:nowTime", nowTime);
    },
    /**
     * @description 后面的几个方法为左侧拖动，右侧拖动，停留拖动的方法
     */
    dragLeftDown() {
      this.enterTimeDown = this.entranceAnim.end;
      this.dragPathDownNum = this.pathAnim.end - this.entranceAnim.end;
      this.getReData();
    },
    dragLeftMove(dx) {
      this.dragLeft = true;
      let changeTime =
        (Math.round(dx / this.forStyle.gridTransform) / 2) * 1000;

      // 不能小于0，不能大于总时间 ,不能大于出场开始时间
      if (
        changeTime + this.enterTimeDown < 0 ||
        changeTime + this.enterTimeDown > this.totalTime * 1000 ||
        changeTime + this.enterTimeDown > this.exitAnim.start
      )
        return;

      if (this.entranceAnim.type === "None") {
        this.entranceAnim.end = this.enterTimeDown + changeTime;
        this.entranceAnim.start = this.entranceAnim.end;
      } else {
        this.entranceAnim.end = this.enterTimeDown + changeTime;
        this.entranceAnim.start = this.entranceAnim.end - 500;
      }

      let dur = this.exitAnim.start - this.entranceAnim.end;
      if (this.hasPathAnim) {
        this.pathAnim.end = this.dragPathDownNum + this.entranceAnim.end;
        if (this.exitAnim.start < this.pathAnim.end) {
          if (dur < 0.001) {
            this.pathAnim.end = this.exitAnim.start + 500;
          } else {
            this.pathAnim.end = this.exitAnim.start;
          }
          this.dragPathDownNum = this.pathAnim.end - this.entranceAnim.end;
        }
      }

      if (this.handAnim) {
        if (dur < this.drawingDuration) {
          if (dur < 0.001) {
            this.drawingDuration = 500;
          } else {
            this.drawingDuration = dur;
          }
          this.dragHandDownNum = this.drawingDuration;
        }
      }

      if (this.nowTime * 1000 < this.entranceAnim.end) {
        this.$emit("update:nowTime", this.entranceAnim.end / 1000);
      }
      this.getStaySectionCss();
    },
    dragLeftUp() {
      if (this.dragLeft) this.getChangeData();
      this.SelectSprites_Msg.length &&
        this.$analysis(
          this.SelectSprites_Msg.length >= 2
            ? this.ANALYSIS.multiDragEnter
            : this.ANALYSIS.sinDragEnter
        );
      this.dragLeft = false;
    },
    dragRightDown() {
      this.exitTimeDown = this.exitAnim.start;
      this.getReData();
    },
    dragRightMove(dx) {
      let changeTime =
        (Math.round(dx / this.forStyle.gridTransform) / 2) * 1000;

      // 不能大于总时间 ,不能小于入场结束时间
      if (
        changeTime + this.exitTimeDown > this.totalTime * 1000 ||
        changeTime + this.exitTimeDown < this.entranceAnim.end
      )
        return;

      if (this.exitAnim.type === "None") {
        this.exitAnim.start = this.exitTimeDown + changeTime;
        this.exitAnim.end = this.exitAnim.start;
      } else {
        this.exitAnim.start = this.exitTimeDown + changeTime;
        this.exitAnim.end = this.exitAnim.start + 500;
      }

      let dur = this.exitAnim.start - this.entranceAnim.end;
      if (this.hasPathAnim) {
        if (this.exitAnim.start < this.pathAnim.end) {
          if (dur < 0.001) {
            this.pathAnim.end = this.exitAnim.start + 500;
          } else {
            this.pathAnim.end = this.exitAnim.start;
          }
        }
      }

      if (this.handAnim) {
        if (dur < this.drawingDuration) {
          if (dur < 0.001) {
            this.drawingDuration = 500;
          } else {
            this.drawingDuration = dur;
          }
          this.dragHandDownNum = this.drawingDuration;
        }
      }

      if (this.nowTime * 1000 > this.exitAnim.start) {
        this.$emit("update:nowTime", this.exitAnim.start / 1000);
      }
      this.getStaySectionCss();
    },
    dragRightUp() {
      if (this.exitAnim.end > this.totalTime * 1000) {
        this.exitAnim.end = this.exitAnim.start;
      }
      for (let i = 0, len = this.sprites.length; i < len; i++) {
        this.sprites[i].updateEffect({
          entranceAnim: {
            end: this.entranceAnim.end,
            start:
              this.sprites[i].effect.code === "None"
                ? this.entranceAnim.end
                : this.entranceAnim.start
          },
          exitAnim: {
            start: this.exitAnim.start,
            end: this.exitAnim.end
          }
        });
      }
      this.$bus.emit("spritesFlagChange", { data: true });
      this.$bus.emit("spritesExitChange");
      this.changePathTime();
      this.changeHandTime();
      this.getChangeData();
      this.SelectSprites_Msg.length &&
        this.$analysis(
          this.SelectSprites_Msg.length >= 2
            ? this.ANALYSIS.multiDragOut
            : this.ANALYSIS.sinDragOut
        );
    },
    dragStayDown() {
      this.enterTimeDown = this.entranceAnim.end;
      this.exitTimeDown = this.exitAnim.start;
      this.dragPathDownNum = this.pathAnim.end;
      this.getReData();
    },
    dragStayMove(dx) {
      this.dragStay = true;
      let changeTime =
        (Math.round(dx / this.forStyle.gridTransform) / 2) * 1000;

      // 入场时间不能小于0，出场不能大于总时间
      if (
        changeTime + this.enterTimeDown < 0 ||
        changeTime + this.exitTimeDown > this.totalTime * 1000
      )
        return;

      if (this.entranceAnim.type === "None") {
        this.entranceAnim.end = this.enterTimeDown + changeTime;
        this.entranceAnim.start = this.entranceAnim.end;
      } else {
        this.entranceAnim.end = this.enterTimeDown + changeTime;
        this.entranceAnim.start = this.entranceAnim.end - 500;
      }

      if (this.exitAnim.type === "None") {
        this.exitAnim.start = this.exitTimeDown + changeTime;
        this.exitAnim.end = this.exitAnim.start;
      } else {
        this.exitAnim.start = this.exitTimeDown + changeTime;
        this.exitAnim.end = this.exitAnim.start + 500;
      }

      if (this.hasPathAnim)
        this.pathAnim.end = this.dragPathDownNum + changeTime;

      if (this.nowTime * 1000 > this.exitAnim.start) {
        this.$emit("update:nowTime", this.exitAnim.start / 1000);
      } else if (this.nowTime * 1000 < this.entranceAnim.end) {
        this.$emit("update:nowTime", this.entranceAnim.end / 1000);
      }
      this.getStaySectionCss();
    },
    dragStayUp() {
      if (this.dragStay) this.getChangeData();
      this.dragStay = false;
    },
    dragPathDown() {
      this.dragPathDownNum = this.pathAnim.end;
    },
    dragPathMove(dx) {
      let changeTime =
        (Math.round(dx / this.forStyle.gridTransform) / 2) * 1000;
      if (
        changeTime + this.dragPathDownNum > this.exitAnim.start ||
        changeTime + this.dragPathDownNum < this.entranceAnim.end + 500
      )
        return;

      this.pathAnim.end = this.dragPathDownNum + changeTime;

      this.getStaySectionCss();
    },
    dragPathUp() {
      this.changePathTime();
      this.$bus.emit("changePath_pathSetting", {
        name: "selection",
        end: this.pathAnim.end
      });
    },
    dragHandDown() {
      this.dragHandDownNum = this.drawingDuration;
      this.getReData();
    },
    dragHandMove(dx) {
      let changeTime =
        (Math.round(dx / this.forStyle.gridTransform) / 2) * 1000;
      if (
        changeTime + this.dragHandDownNum >
          this.exitAnim.start - this.entranceAnim.end ||
        changeTime + this.dragHandDownNum < 500
      )
        return;

      this.drawingDuration = this.dragHandDownNum + changeTime;
      this.getStaySectionCss();
    },
    dragHandUp() {
      this.changeHandTime();
      this.getChangeData();
      this.$analysis(this.ANALYSIS.sinDragHand);
    },
    changePathTime() {
      for (let i = 0, len = this.pathSprites.length; i < len; i++) {
        this.pathSprites[i].updateEffect(
          {
            pathAnim: {
              start: this.entranceAnim.end,
              end: this.pathAnim.end
            }
          },
          true
        );
      }
    },
    changeHandTime() {
      for (let i = 0, len = this.handSprites.length; i < len; i++) {
        if (this.handAnim) {
          this.handSprites[i].updateEffect({
            drawingDuration: this.drawingDuration
          });
        } else {
          let effect = this.handSprites[i].effect;
          let dur = effect.exitAnim.start - effect.entranceAnim.end;
          dur < 500 && (dur = 500);
          if (effect.drawingDuration > dur) {
            this.handSprites[i].updateEffect({
              drawingDuration: dur
            });
          }
        }
      }
    },
    showEffectPopup({ type } = {}, ev) {
      let ele = ev.currentTarget;
      let rect = ele.getBoundingClientRect();
      let initialX = type === "enter" ? rect.left : rect.right - 260;
      let initialY = rect.top - 367 - 40;

      this.$nextTick(() => {
        this.$bus.emit("FeaturesPop_vue", {
          name: "inOutEffect",
          initialX,
          initialY,
          rect: rect,
          type: 1,
          effectType: type
        });
      });
    },
    settingStayAnim(e) {
      this.$bus.emit("FeaturesPop_vue", {
        type: 1,
        name: "stayEffect",
        sprite: this.SelectSprites_Msg[0],
        initialX: e.pageX - e.offsetX - 100,
        initialY: e.pageY - e.offsetY - 200
      });
      this.$analysis(this.ANALYSIS.stayAnim);
    },
    isDrawEffect(code) {
      return /^(?:draw|hand|write)$/i.test("" + code);
    },
    isAppearEffect(code) {
      return /^(?:appear|type|bounce|roll)$/i.test("" + code);
    },
    isSpecialEffect(code) {
      return this.isDrawEffect(code) || this.isAppearEffect(code);
    },
    getReData() {
      this.reData = [];
      this.sprites.forEach(s => {
        let info = {
          id: s.id,
          data: {
            entranceAnim: {
              start: s.effect.entranceAnim.start,
              end: s.effect.entranceAnim.end
            },
            exitAnim: {
              start: s.effect.exitAnim.start,
              end: s.effect.exitAnim.end
            },
            pathAnim: this.hasPathAnim
              ? {
                  start: s.effect.pathAnim.start,
                  end: s.effect.pathAnim.end
                }
              : null
          }
        };
        if (s.effect.code === "Hand") {
          info.data.drawingDuration = s.effect.drawingDuration;
        }
        this.reData.push(info);
      });
    },
    getChangeData() {
      this.changeData = [];
      this.sprites.forEach(s => {
        let info = {
          id: s.id,
          data: {
            exitAnim: {
              end: this.exitAnim.end,
              start: this.exitAnim.start
            },
            entranceAnim: {
              end: this.entranceAnim.end,
              start: this.entranceAnim.start
            },
            pathAnim: this.hasPathAnim
              ? {
                  start: this.entranceAnim.end,
                  end: this.pathAnim.end
                }
              : null
          }
        };
        if (s.effect.code === "Hand") {
          info.data.drawingDuration = s.effect.drawingDuration;
        }
        this.changeData.push(info);
      });

      eve("undo_redo", null, {
        type: "timeline_drag",
        data: {
          scenesId: this.SelectScenes_Msg.id,
          reData: this.reData,
          changeData: this.changeData
        }
      });
    }
  },
  directives: {
    dragLeft(el, binding, vnode) {
      let _this = vnode.context,
        mousemove = null,
        mouseup = null,
        disx = 0;

      mousemove = e => {
        let dx = e.pageX - disx;

        _this.dragLeftMove(dx);
      };

      mouseup = e => {
        document.removeEventListener("mousemove", mousemove);
        document.removeEventListener("mouseup", mouseup);

        _this.dragLeftUp();
      };

      el.onmousedown = e => {
        e.preventDefault();

        disx = e.pageX;

        document.addEventListener("mousemove", mousemove);
        document.addEventListener("mouseup", mouseup);

        _this.dragLeftDown();
      };
    },
    dragRight(el, binding, vnode) {
      let _this = vnode.context,
        mousemove = null,
        mouseup = null,
        disx = 0;

      mousemove = e => {
        let dx = e.pageX - disx;

        _this.dragRightMove(dx);
      };

      mouseup = e => {
        document.removeEventListener("mousemove", mousemove);
        document.removeEventListener("mouseup", mouseup);

        _this.dragRightUp();
      };

      el.onmousedown = e => {
        e.preventDefault();

        disx = e.pageX;

        document.addEventListener("mousemove", mousemove);
        document.addEventListener("mouseup", mouseup);

        _this.dragRightDown();
      };
    },
    dragStay(el, binding, vnode) {
      let _this = vnode.context,
        mousemove = null,
        mouseup = null,
        disx = 0;

      mousemove = e => {
        let dx = e.pageX - disx;

        _this.dragStayMove(dx);
      };

      mouseup = e => {
        document.removeEventListener("mousemove", mousemove);
        document.removeEventListener("mouseup", mouseup);

        _this.dragStayUp();
      };

      el.onmousedown = e => {
        e.preventDefault();

        disx = e.pageX;

        document.addEventListener("mousemove", mousemove);
        document.addEventListener("mouseup", mouseup);

        _this.dragStayDown();
      };
    },
    dragPath(el, binding, vnode) {
      let _this = vnode.context,
        mousemove = null,
        mouseup = null,
        disx = 0;

      mousemove = e => {
        let dx = e.pageX - disx;

        _this.dragPathMove(dx);
      };

      mouseup = e => {
        document.removeEventListener("mousemove", mousemove);
        document.removeEventListener("mouseup", mouseup);

        _this.dragPathUp();
      };

      el.onmousedown = e => {
        e.stopPropagation();
        e.preventDefault();

        disx = e.pageX;

        document.addEventListener("mousemove", mousemove);
        document.addEventListener("mouseup", mouseup);

        _this.dragPathDown();
      };
    },
    dragHand(el, binding, vnode) {
      let _this = vnode.context,
        mousemove = null,
        mouseup = null,
        disx = 0;

      mousemove = e => {
        let dx = e.pageX - disx;

        _this.dragHandMove(dx);
      };

      mouseup = e => {
        document.removeEventListener("mousemove", mousemove);
        document.removeEventListener("mouseup", mouseup);

        _this.dragHandUp();
      };

      el.onmousedown = e => {
        e.stopPropagation();
        e.preventDefault();

        disx = e.pageX;

        document.addEventListener("mousemove", mousemove);
        document.addEventListener("mouseup", mouseup);

        _this.dragHandDown();
      };
    },
    clickSelection(el, binding, vnode) {
      // 点击事件（为了和拖拽不冲突）
      let _this = vnode.context,
        mousemove = null,
        mouseup = null,
        isClick = false,
        dis = {
          x: 0,
          y: 0
        };

      mousemove = e => {
        if (Math.abs(e.pageX - dis.x) >= 3 || Math.abs(e.pageY - dis.y) >= 3) {
          isClick = true;
        }
      };

      mouseup = e => {
        document.removeEventListener("mousemove", mousemove);
        document.removeEventListener("mouseup", mouseup);

        if (isClick) return;
        _this.toNowTime(e);
      };

      el.onmousedown = e => {
        e.preventDefault();
        // e.stopPropagation();

        isClick = false;
        dis.x = e.pageX;
        dis.y = e.pageY;

        document.addEventListener("mousemove", mousemove);
        document.addEventListener("mouseup", mouseup);
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.timeline-selection {
  position: relative;
  height: 30px;
  background-color: #d4d6e6;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;

  .effect-chooser {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;

    .enter-effect-icon,
    .exit-effect-icon {
      position: absolute;
      height: 100%;
      top: 0;
      left: -36px;
      display: flex;
      -webkit-box-align: center;
      align-items: center;
      justify-content: center;
      z-index: 101;
      width: 30px;
      cursor: pointer;

      i {
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        background-position: center;
        width: 22px;
        height: 30px;
        background-repeat: no-repeat;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        opacity: 1;
      }
      .anim-write,
      .anim-Write,
      .anim-None,
      .anim-Hand,
      .anim-Draw,
      .anim-Entrance,
      .anim-LeftIn,
      .anim-RightIn,
      .anim-UpIn,
      .anim-DownIn,
      .anim-SmearLeftIn,
      .anim-SmearRightIn,
      .anim-SmearUpIn,
      .anim-SmearDownIn,
      .anim-Smear,
      .anim-Appear,
      .anim-PopIn,
      .anim-FadeIn,
      .anim-Type,
      .icon-enter-effect {
        background: url("../../../../static/svg/timeline-enter-animation.svg")
          no-repeat center;
      }
      .anim-Exit,
      .anim-LeftOut,
      .anim-RightOut,
      .anim-UpOut,
      .anim-DownOut,
      .anim-SmearLeftOut,
      .anim-SmearRightOut,
      .anim-SmearUpOut,
      .anim-SmearDownOut,
      .anim-Smear.anim-out,
      .anim-PopOut,
      .anim-FadeOut {
        background: url("../../../../static/svg/timeline-exit-animation.svg")
          no-repeat center;
      }
    }
    .exit-effect-icon {
      left: 6px;
      .anim-None,
      .anim-PopOut,
      .anim-FadeOut {
        background: url("../../../../static/svg/timeline-exit-animation.svg")
          no-repeat center;
      }
    }
    .enter-effect-section,
    .exit-effect-section {
      position: absolute;
      content: "";
      width: 0;
      height: 0;
      top: 0;
      border-style: solid;
      left: 0;
      margin-left: 0;
      border-width: 0 0 30px 0;
      border-color: transparent transparent #b4b8d6 transparent;
    }

    .exit-effect-section {
      margin-left: 2px;
      border-width: 30px 0 0 0;
      border-color: transparent transparent transparent #b4b8d6;
    }
  }

  .stay-section {
    background-color: #b4b8d6;
    height: 100%;
    cursor: pointer;
    position: absolute;
    text-align: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    overflow: hidden;

    .path-animation-section {
      background-color: #2279cc;
      height: 30px;
      position: absolute;

      > span {
        display: block;
        position: relative;
        left: calc(50% - 19px);
        top: 2px;
        width: 26px;
        height: 26px;
        background: url("../../../../static/svg/timeline-stay-setting.svg")
          no-repeat center;
      }

      > span.loop-icon {
        display: block;
        position: absolute;
        top: 4px;
        left: calc(100% - 31px);
        width: 22px;
        height: 22px;
        background: url("../../../../static/svg/path-loop.svg") no-repeat;
      }

      .path-animation-handle {
        height: 30px;
        top: 0px;
        position: absolute;
        left: -3px;
        padding: 0 2px;
        cursor: ew-resize;

        > div {
          height: 30px;
          width: 3px;
          background: #474261;
        }
      }
    }

    .hand-animation-section {
      background-color: #2279cc;
      height: 30px;
      position: absolute;

      .hand-animation-handle {
        height: 30px;
        top: 0px;
        position: absolute;
        left: -4px;
        padding: 0 2px;
        cursor: ew-resize;

        > div {
          height: 30px;
          width: 3px;
          background: #474261;
        }
      }
    }

    i.icon-stay-setting {
      display: inline-block;
      width: 26px;
      height: 26px;
      background: url("../../../../static/svg/timeline-stay-setting.svg")
        no-repeat center;
    }

    span.handAnim-icon {
      display: block;
      position: absolute;
      top: 4px;
      left: calc(100% - 31px);
      width: 22px;
      height: 22px;
      background: url("../../../../static/svg/popups/clip-bg-3.svg") no-repeat;
    }
  }

  .timeline-drag-left,
  .timeline-drag-right {
    height: 34px;
    top: -2px;
    cursor: ew-resize;
    position: absolute;
    left: -3px;
    padding: 0 2px;

    div {
      background: #474261;
      height: 100%;
      width: 3px;
    }
  }
}

.no-selection {
  position: relative;
  height: 30px;
  background-color: #d4d6e6;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/tool/timeline/selection.vue